module.exports = __webpack_public_path__ + "static/media/GIF.84a712bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/GIF.svg
// module id = 1680
// module chunks = 17